
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auslandsversandkosten",
      function () {
        return require("private-next-pages/auslandsversandkosten.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auslandsversandkosten"])
      });
    }
  